import React, { useContext, useState } from "react";
import cx from "classnames";
import { DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, TabContent, UncontrolledDropdown } from "reactstrap";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import PFont from "./PFont";
import PColor from "./PColor";
import { PRICING_TABLE, TIMELINE, SCOPE_OF_WORK, ITINERARY, PORTFOLIO, CASESTUDY } from "../../../constants/editor";
import TColor from "./TColor";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import TFont from "./TFont";
import SColor from "./SColor";
import SFont from "./SFont";
import IColor from "./IColor";
import IFont from "./IFont";
import CColor from "./CColor";
import CFont from "./CFont";

let style = Object.assign({}, global);

const PricingTableStyle = () => {
  let { metadata } = useContext(EditorContext);

  const PricingTableStyleList = ["Color", "Font"];
  const iconClassName = {
    Color: "color",
    Font: "text",
  };

  const [activeTab, setActiveTab] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropDown = () => {
    setDropdownOpen(prevState => !prevState);
  };

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <li className={cx(style["toolset-group"])}>
      <UncontrolledDropdown
        className={cx(style["toolset-item"], style["style-wrap"])}
        isOpen={dropdownOpen}
        toggle={toggleDropDown}>
        <DropdownToggle tag="a" className={cx(style["toolset-action"], style["custom-tooltip"])}>
          <Icon icon="ui-adjust" />
          <div className={cx(style["custom-tooltip-content"], style["top"])}>Adjust Style</div>
        </DropdownToggle>
        <DropdownMenu className={cx(style["shadow"], style["border-0"], style["rounded"])}>
          <Nav pills>
            {PricingTableStyleList?.map((contextMenue, idx) => (
              <NavItem key={idx}>
                <NavLink
                  className={cx({ active: activeTab === idx })}
                  onClick={() => {
                    toggle(idx);
                  }}>
                  <Icon icon={`ui-${iconClassName[contextMenue]}`} />
                  {contextMenue}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          {activeTab === 0 && (
            <TabContent activeTab={activeTab} className={style["mt-3"]}>
              {metadata.activeWidgetType[0] === PRICING_TABLE && <PColor />}
              {metadata.activeWidgetType[0] === TIMELINE && <TColor />}
              {metadata.activeWidgetType[0] === SCOPE_OF_WORK && <SColor />}
              {metadata.activeWidgetType[0] === ITINERARY && <IColor />}
              {[PORTFOLIO, CASESTUDY].includes(metadata.activeWidgetType[0]) && <CColor />}
            </TabContent>
          )}
          {activeTab === 1 && (
            <TabContent activeTab={activeTab} className={style["mt-3"]}>
              {metadata.activeWidgetType[0] === PRICING_TABLE && <PFont />}
              {metadata.activeWidgetType[0] === TIMELINE && <TFont />}
              {metadata.activeWidgetType[0] === SCOPE_OF_WORK && <SFont />}
              {metadata.activeWidgetType[0] === ITINERARY && <IFont />}
              {[PORTFOLIO, CASESTUDY].includes(metadata.activeWidgetType[0]) && <CFont />}
            </TabContent>
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    </li>
  );
};

export default PricingTableStyle;
